import React from 'react';
import { Card, Center } from '@mantine/core';
import { Navigate, useLoaderData, useParams } from 'react-router-dom';
import ClientForm from './Form';
import { updateClient } from '../../Util/server';
import { AggregatedDataLoaderResult } from '../../Loaders/AggregatedDataLoader';
import { SubmittableClient } from '../../../backend/models/client';

const UpdateClient = () => {
  const { technologies, clients, persons } = useLoaderData() as AggregatedDataLoaderResult;
  const { name } = useParams();

  const client = clients.find((t) => t.name === name);

  if (client === undefined || client?.id === undefined) {
    return <Navigate to={'/'} replace />;
  }

  return (
    <Center>
      <Card
        withBorder
        shadow="sm"
        sx={() => ({
          overflow: 'visible',
        })}
      >
        <ClientForm
          data={client}
          persons={persons}
          technologies={technologies}
          names={clients.map((t) => t.name)}
          buttonLabel="Save"
          onSubmit={(values: SubmittableClient) => updateClient(values, client.id)}
          add={false}
          successMessage="Client updated successfully"
        />
      </Card>
    </Center>
  );
};

export default UpdateClient;
